// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__10z-J","title":"FrontImage_title__s9EEi"};